import React from "react";
import "./MathDirections.scss";

const MathDirections = () => {
  return (
    <div className="container">
      <h3 className="section-title">
        The questions in this section address a number of important math skills.
      </h3>
      <p className="instructions">
        Use of a calculator is permitted for all questions. A reference sheet,
        calculator, and these directions can be accessed throughout the test.
      </p>

      <p className="subtext">Unless otherwise indicated:</p>
      <ul className="list">
        <li>All variables and expressions represent real numbers.</li>
        <li>Figures provided are drawn to scale.</li>
        <li>All figures lie in a plane.</li>
        <li>
          The domain of a given function f is the set of all real numbers x for
          which f(x) is a real number.
        </li>
      </ul>

      <p className="instructions">
        For <strong>multiple-choice questions</strong>, solve each problem and
        choose the correct answer from the choices provided. Each
        multiple-choice question has a single correct answer.
      </p>
      <p className="instructions">
        Each multiple-choice question has a single correct answer.
      </p>

      <p className="instructions">
        For <strong>student-produced response questions</strong>, solve each
        problem and enter your answer as described below.
      </p>
      <ul className="list">
        <li>
          If you find <strong>more than one correct answer</strong>, enter only
          one answer.
        </li>
        <li>
          You can enter up to 5 characters for a <strong>positive</strong>{" "}
          answer and up to 6 characters (including the negative sign) for a{" "}
          <strong>negative</strong> answer.
        </li>
        <li>
          If your answer is a <strong>fraction</strong> that doesn’t fit in the
          provided space, enter the decimal equivalent.
        </li>
        <li>
          If your answer is a <strong>decimal</strong> that doesn’t fit in the
          provided space, enter it by truncating or rounding at the fourth
          digit.
        </li>
        <li>
          If your answer is a <strong>mixed number</strong> (such as 3
          <sup>1</sup>&frasl;<sub>2</sub>), enter it as an improper fraction
          (7/2) or its decimal equivalent (3.5).
        </li>
      </ul>
    </div>
  );
};

export default MathDirections;
